(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-notes"] && !Shopify.designMode) return;
  try {
    class ProductNotes extends HTMLElement {
    constructor() {
      super();
      this.onClick = this.onClick.bind(this);
      this.onClose = this.onClose.bind(this);
    }

    connectedCallback() {
      if (this.dataset.bound === 'true') return;
      this.dataset.bound = 'true';
      this.drawer = this.querySelector('[data-product-details-drawer]');
      this.drawer?.addEventListener('theme-drawer:close', this.onClose);
      document.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.dataset.bound = 'false';
      document.removeEventListener('click', this.onClick);
      this.drawer?.removeEventListener('theme-drawer:close', this.onClose);
      if (this.drawer && this.drawer.parentElement === document.body) this.drawer.remove();
    }

    onClose() {
      document.querySelectorAll('[data-product-panel][aria-expanded="true"]').forEach((button) => {
        button.setAttribute('aria-expanded', 'false');
      });
    }

    onClick(event) {
      const trigger = event.target instanceof Element ? event.target.closest('[data-product-panel]') : null;
      if (!trigger || !this.drawer) return;
      const id = trigger.dataset.productPanel;
      if (!id) return;
      this.drawer.querySelectorAll('[data-panel-body]').forEach((panel) => {
        panel.hidden = panel.dataset.panelBody !== id;
      });
      const heading = this.drawer.querySelector('#product-details-drawer-heading');
      if (heading && trigger.dataset.panelTitle) heading.textContent = trigger.dataset.panelTitle;
      document.querySelectorAll('[data-product-panel]').forEach((button) => {
        button.setAttribute('aria-expanded', button === trigger ? 'true' : 'false');
      });
      if (this.drawer.parentElement !== document.body) document.body.append(this.drawer);
      customElements.upgrade(this.drawer);
      if (typeof this.drawer.open === 'function' && !this.drawer.isOpen) this.drawer.open();
    }
  }

  if (!customElements.get('product-notes')) {
    customElements.define('product-notes', ProductNotes);
  }
  } catch(e) { console.error(e); }
})();

})();
